export default async function loaderStop({ context, nextMiddleware }) {
  try {
    await context.store.dispatch('setLoader');
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
